import { observer } from 'mobx-react-lite'
import { CarrierVisitAllocationRulesViewStore } from '../../stores/allocation-rules/carrier-visit-allocation-rules.view-store'
import { GlobalAllocationRulesViewStore } from '../../stores/allocation-rules/global-allocation-rules.view-store'
import { CarrierVisitOverviewViewStore } from '../../stores/carrier-visit-overview.viewstore'
import { HousekeepingPlanAccumulatorViewStore } from '../../stores/housekeeping-plan-accumulator.view-store'
import { YardViewStore } from '../../stores/yard.view-store'
import { CarrierVisitAllocationRulesDrawer } from './AllocationRules/CarrierVisitAllocationRules/CarrierVisitAllocationRulesDrawer'
import { GlobalAllocationRulesDrawer } from './AllocationRules/GloballAllocationRules/GlobalAllocationRulesDrawer'
import { CarrierVisitOverviewDrawer } from './CarrierVisitOverview/CarrierVisitOverviewDrawer'
import { HousekeepingPlanAccumulatorDrawer } from './HousekeepingPlan/HousekeepingPlanAccumulatorDrawer'
import { YardViewFiltersDrawer } from './YardViewFiltersDrawer'

interface Props {
  yardViewStore: YardViewStore
  globalAllocationRulesViewStore: GlobalAllocationRulesViewStore
  carrierVisitAllocationRulesViewStore: CarrierVisitAllocationRulesViewStore
  carrierVisitOverviewViewStore: CarrierVisitOverviewViewStore
  housekeepingPlanAccumulatorViewStore: HousekeepingPlanAccumulatorViewStore
}

export const YardDrawers = observer((props: Props) => {
  const {
    yardViewStore,
    globalAllocationRulesViewStore,
    carrierVisitAllocationRulesViewStore,
    carrierVisitOverviewViewStore,
    housekeepingPlanAccumulatorViewStore,
  } = props

  return (
    <>
      <GlobalAllocationRulesDrawer
        yardViewStore={yardViewStore}
        globalAllocationRulesViewStore={globalAllocationRulesViewStore}
      />
      <CarrierVisitAllocationRulesDrawer
        yardViewStore={yardViewStore}
        carrierVisitAllocationRulesViewStore={carrierVisitAllocationRulesViewStore}
        globalAllocationRulesViewStore={globalAllocationRulesViewStore}
      />
      <CarrierVisitOverviewDrawer
        yardViewStore={yardViewStore}
        carrierVisitOverviewViewStore={carrierVisitOverviewViewStore}
        carrierVisitAllocationRulesViewStore={carrierVisitAllocationRulesViewStore}
        globalAllocationRulesViewStore={globalAllocationRulesViewStore}
      />
      <HousekeepingPlanAccumulatorDrawer
        yardViewStore={yardViewStore}
        housekeepingPlanAccumulatorViewStore={housekeepingPlanAccumulatorViewStore}
      />
      <YardViewFiltersDrawer
        viewStore={yardViewStore}
        carrierVisitAllocationRulesViewStore={carrierVisitAllocationRulesViewStore}
        globalAllocationRulesViewStore={globalAllocationRulesViewStore}
      />
    </>
  )
})
